module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Tools/Shovel-4d4fb7fcd6ac3428152662bf1904431578d1e74cebb9495b40ed402eed78933d.svg";